import { Vue } from "vue"
export default {
    state:{ 
        batchIdsArr:[],
        batchIdsAnalysis:[],
        analysisNum:0,
    },
    mutations:{},
    actions: {}
}